import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faR } from '@fortawesome/free-solid-svg-icons';
import { cloneDeep } from 'lodash';
import { MessageService, MenuItem, TreeNode } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { Location } from '@angular/common';

@Component({
  selector: 'app-add-training-program',
  templateUrl: './add-training-program.component.html',
  styleUrl: './add-training-program.component.scss',
  providers: [MessageService],
})
export class AddTrainingProgramComponent implements OnChanges {
  @Output() closeForm: EventEmitter<any> = new EventEmitter();
  @Input() programData: any = undefined;
  @Input() programType: any;
  @Input() isSkillTraining: boolean = false;

  items!: MenuItem[];
  staticURL = GlobalConstants.staticFilesURL;
  activeIndex: number = 0;
  selectedOus: any = [];
  trainingProgramForm!: FormGroup;

  //training
  trainingTypes: any;
  trainingFilter: any;
  oufilter: any;
  page: number = 1;
  rows: number = 10;
  first = 1;
  totalTraining: number = 0;
  trainingSpinner = false;
  trainingData: any = [];
  selectTrainings: boolean = true;
  trainingHolder: any;

  //new training
  addNewTraining: boolean = false;
  newTrainingType: any;
  openCreateTrainingForm: boolean = false;
  trainingUserSpinner: boolean = false;
  allowedTrainingTypes: string[] = [];

  trainingUser: any;

  trainingProgramUser: any;
  trainingProgramUserSpinner: boolean = false;
  filteredTrainingProgramUser: any;
  createdProgramId: string = '';

  recreteSection: any = {
    show: false,
    returnObject: undefined,
    courseId: undefined,
    course: {},
  };

  constructor(
    public messageService: MessageService,
    private orgUnits: OrgUnitsService,
    private fb: FormBuilder,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private permissionService: PermissionHandlerService,
    private location: Location
  ) { }

  onActiveIndexChange(event: any) {
    this.activeIndex = event;
  }

  ngOnInit() {
    this.activeIndex = 0;
    this.createtrainingProgramForm();
    this.extractAllowedTrainingTypes();
    Promise.all([
      this.getTreeData(),
      this.getTrainingTypes(),
      this.getInternalTrainers(),
    ]).then(() => {
      this.getTrainingRequests();
      if (this.programData) {
       //debugger

        this.selectedOus = [];
        this.findAndPushMatchingOUs(
          this.selectedTreeData,
          this.programData.ous.map((e: any) => e._id),
          this.selectedOus
        );
        this.trainingProgramForm.patchValue({
          title: this.programData?.title,
          description: this.programData?.description,
        });
        // this.getTrainingUsers()
        this.getTrainingProgramUsers();
        console.log('FORM DATA', this.programData?.courses);
        this.programData?.courses.map((e: any) =>
          this.courses.push(this.groupCourse(e))
        );

        let x = this.programData.getRawValue;
        this.cdr.detectChanges();
      }
    });

    this.items = [
      {
        label: this.translate('Assign Ous'),
        command: (event: any) => {
          this.activeIndex = 0;
        },
      },
      {
        label: this.translate('Program Form'),
        command: (event: any) => this.openProgramDetailForm(),
      },
      {
        label: this.translate('Select Trainings'),
        command: (event: any) => this.submitTrainingForm(),
      },
      {
        label: this.translate('Confirmation'),
        command: (event: any) => this.openConfirmation(),
      },
    ];
  }

  extractAllowedTrainingTypes() {
    // this.allowedTrainingTypes = this.permissionService.extractTags('TRAINING_PROGRAM', 'c')
    this.allowedTrainingTypes = [this.programType];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['programData']) {
      // this.programData
      // this.selectedOus = []
      // this.findAndPushMatchingOUs(this.selectedTreeData, this.programData.ous.map((e:any)=>e._id), this.selectedOus);
      // this.createtrainingProgramForm()
      // this.trainingProgramForm.patchValue({title : this.programData?.title, description: this.programData?.description })
      // this.programData?.courses.map((e:any)=> this.courses.push(this.fb.group(e)))
      // this.cdr.detectChanges()
      //
    }
  }

  findAndPushMatchingOUs(ous: any[], ids: string[], selectedOUs: any[]) {
    ous.forEach((ou) => {
      if (ids.includes(ou._id)) {
        selectedOUs.push(ou);
      }

      // Recursively check children OUs
      if (ou.children && ou.children.length > 0) {
        this.findAndPushMatchingOUs(ou.children, ids, selectedOUs);
      }
    });
  }

  async getTrainingTypes() {
    try {
      let res = await this.dataService.postData(
        'training-type/get/?offset=1000&page=1',
        {}
      );
      if (res.error) {
        return;
      }
      this.trainingTypes = res.data
        .filter(
          (e: any) =>
            e.name !== 'Weely' &&
            e.name !== 'Unified session' &&
            this.allowedTrainingTypes.includes(e._id)
        )
        .map((e: any) => {
          return { ...e, label: e.arabic };
        });

      this.newTrainingType = this.trainingTypes[0];
    } catch (error) {
      console.log(error);
    }
  }

  getTrainingRequests = async () => {
    try {
      // 'this.trainingTypes.map((e: any) => e._id)'   trining program on training request measures

      let query: any = {
        active: true,
        status: ['PUBLISHED', 'TRAINING_CREATED', 'COMPLETED'],
        type: this.programType,
        ous: this.flattenTree(this.selectedTreeData),
        allowedNullOu: true,
      };

      if (this.oufilter) {
        query.ous = [this.oufilter._id];
      }

      if (this.trainingFilter) {
        query.type = this.trainingFilter._id;
      }

      this.trainingSpinner = true;

      this.trainingData = [];

      if (query?.ous?.length <= 0) {
        delete query.ous;
      }

      let res = await this.dataService.postData(
        `training-req/get-aggregated-v2?offset=${this.rows}&page=${this.page}`,
        query
      );

      if (res.error) {
        return;
      }

      this.totalTraining = res?.data?.totalCount;
      this.trainingData = res?.data?.data;
      this.trainingSpinner = false;

      // this.filterByMonth();
    } catch (error) {
      console.log(error);
    }
  };

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.page = event.page + 1;
    this.getTrainingRequests();
  }

  addTraining() { }

  openProgramDetailForm() {
    if (!this.selectedOus || this.selectedOus.length <= 0) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Please Select Ou'),
        detail: '',
      });
      return;
    }

    this.getTrainingProgramUsers();
    this.activeIndex = 1;
  }

  openConfirmation() {
    if (!this.selectedOus || this.selectedOus.length <= 0) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Please Select Ou'),
        detail: '',
      });
      return;
    }

    if (!this.trainingProgramForm.valid) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Form Details invalid'),
        detail: '',
      });
      return;
    }

    this.getTrainingProgramUsers();
    this.calculateTrainingStartEndDate();

    this.activeIndex = 3;
  }

  programStartDate: any;
  programEndDate: any;

  calculateTrainingStartEndDate() {
    let courses = this.trainingProgramForm.getRawValue().courses;
    console.log(courses);
    let nearestStartDate: any = null;
    let farthestEndDate: any = null;

    courses.forEach((course: any) => {
      const startDate = !!course.recreationData
        ? new Date(course.recreationData.start_date)
        : new Date(course.trainingId.start_date);

      const endDate = !!course.recreationData
        ? new Date(course.recreationData.end_date)
        : new Date(course.trainingId.end_date);

      if (!nearestStartDate || startDate < nearestStartDate) {
        nearestStartDate = startDate;
        (this.programStartDate = nearestStartDate
          ? nearestStartDate.toISOString()
          : null),
          (this.programEndDate = farthestEndDate
            ? farthestEndDate.toISOString()
            : null);
      }

      if (!farthestEndDate || endDate > farthestEndDate) {
        farthestEndDate = endDate;
      }
    });
    console.log(nearestStartDate, farthestEndDate);

    (this.programStartDate = nearestStartDate
      ? nearestStartDate.toISOString()
      : null),
      (this.programEndDate = farthestEndDate
        ? farthestEndDate.toISOString()
        : null);
  }

  createtrainingProgramForm() {
    this.trainingProgramForm = this.fb.group({
      title: ['', Validators.required],
      master_trainer: [''],
      description: ['', Validators.required],
      courses: this.fb.array([]),
      type: [this.programType],
    });
    if (this.programType === '654e867bb9f4c5b8996191c5' && !this.programData?.master_trainer) {
      this.trainingProgramForm
        .get('master_trainer')
        ?.setValidators(Validators.required);
      this.trainingProgramForm.get('master_trainer')?.updateValueAndValidity();
    }
  }

  get courses(): FormArray {
    return this.trainingProgramForm.get('courses') as FormArray;
  }

  isEndDatePassed(end_date: string): boolean {
    const currentDate = new Date();
    const endDate = new Date(end_date);
    return endDate < currentDate;
  }

  resetRecreateObject() {
    this.recreteSection = {
      show: false,
      returnObject: undefined,
      courseId: undefined,
      recreateOptionFlag: undefined,
      selectedRecreateOption: undefined,
      course: {},
    };
  }

  recreateOptions: any[] = [
    {
      name: this.translate('Merge Users'),
      key: 'Merge Users',
      newOnly: false,
      newOnes: false,
    },
    {
      name: this.translate('Add all incomplete users into a copy'),
      key: 'Incomplete into copy',
      newOnly: false,
      newOnes: false,
    },
    {
      name: this.translate('Add no existing others users into copy'),
      key: 'Non existing into copy',
      newOnly: true,
      newOnes: false,
    },
    {
      name: this.translate('Add all ou users'),
      key: 'Add all ou users',
      newOnly: true,
      newOnes: true,
    },
  ];

  addCourse(event: any, course: any): void {
    event.stopPropagation();

    this.resetRecreateObject();

    if (this.isCourseAdded(course) || !!!course.trainingId) return;

    //opening pannel
    this.trainingHolder = course;
    this.filteredTrainingProgramUser = this.trainingProgramUser.filter(
      (programUser: any) =>
        !this.trainingUser?.some((user: any) => user._id === programUser._id)
    );

    if (
      this.isEndDatePassed(course?.trainingId?.start_date) &&
      course.status !== 'TRAINING_CREATED'
    ) {
      this.recreteSection.courseId = course?.trainingId?._id;
      let find = this.recreateOptions.find(
        (e) => e.name == this.translate('Merge Users')
      );
      if (!this.isEndDatePassed(course?.trainingId?.end_date)) {
        this.recreteSection.recreateOptionFlag = true;
        if (!find) {
          this.recreateOptions.push({
            name: this.translate('Merge Users'),
            key: 'Merge Users',
            newOnly: false,
            newOnes: false,
          });
        }
      } else {
        if (find) {
          this.recreateOptions = this.recreateOptions.filter(
            (e) => e.name != this.translate('Merge Users')
          );
        }

        this.recreteSection.recreateOptionFlag = true;
      }
      this.recreteSection.show = true;

      this.recreteSection.course = cloneDeep(course);

      this.cdr.detectChanges();
      return;
    }

    let x = this.trainingProgramForm.getRawValue();

    this.courses.push(this.groupCourse(course));
    this.cdr.detectChanges();
  }

  addUpdatedCourse(event: any) {
    if (
      !this.recreteSection.selectedRecreateOption?.key &&
      this.recreteSection.recreateOptionFlag == true
    )
      return;

    let courseSetting: any;

    courseSetting = {
      newOnly: this.recreteSection.selectedRecreateOption.newOnly,
      process: this.recreteSection.selectedRecreateOption.key,
      newOnes: this.recreteSection.selectedRecreateOption.newOnes,
    };

    let course: any = { ...this.recreteSection.course, recreationData: event };

    // if (this.recreteSection.recreateOptionFlag == true) {

    // }
    course.conditions = courseSetting;

    this.courses.push(this.groupCourse(course));
    this.cdr.detectChanges();
    this.resetRecreateObject();
  }

  chanegRecreateOptionFlag(flag: boolean) {
    if (this.recreteSection.selectedRecreateOption.key == 'Merge Users') {
      let courseSetting: any = {
        newOnly: this.recreteSection.selectedRecreateOption.newOnly,
        process: this.recreteSection.selectedRecreateOption.key,
      };
      let course: any = {
        ...this.recreteSection.course,
        conditions: courseSetting,
      };
      this.courses.push(this.groupCourse(course));
      this.cdr.detectChanges();
      this.resetRecreateObject();
      return;
    }

    flag ? (this.recreteSection.recreateOptionFlag = false) : null;
    this.cdr.detectChanges();
  }

  removeCourse(course: any, updateFalg = false): void {
    const index = this.courses.controls.findIndex(
      (ctrl) => ctrl.value.trainingId._id == course.trainingId._id
    );
    if (index !== -1) {
      this.courses.removeAt(index);
      this.cdr.detectChanges();
      if (updateFalg) {
        this.calculateTrainingStartEndDate();
      }
    }
  }

  isCourseAdded(course: any): boolean {
    return this.courses.controls.some(
      (ctrl) => ctrl.value.trainingId?._id == course.trainingId?._id
    );
  }

  openTrainingPanel(req: any) {
    this.trainingHolder = req;
    this.resetRecreateObject();
    this.getTrainingUsers().then(() => {
      this.filteredTrainingProgramUser = this.trainingProgramUser;

      this.filteredTrainingProgramUser = this.trainingProgramUser.filter(
        (programUser: any) =>
          !this.trainingUser.some((user: any) => user._id === programUser._id)
      );
    });
  }

  private getTrainingUsers = async () => {
    try {
      this.trainingUserSpinner = true;
      let id = this.trainingHolder.trainingId._id;

      if (!id) return;

      let res = await this.dataService.getData('course/completed-users/' + id);
      if (res.error) {
        return;
      }
      this.trainingUser = res.data;
      this.trainingUserSpinner = false;
      return;
    } catch (error) {
      console.log(error);
    }
  };

  getTrainingProgramUsers = async () => {
    try {
      this.trainingProgramUserSpinner = true;
      let query: any = {
        ou: { $in: this.selectedOus.map((e: any) => e._id) },
      };

      let res = await this.dataService.postData('user/get', query);
      if (res.error) {
        return;
      }
      this.trainingProgramUser = res.data;
      this.trainingProgramUserSpinner = false;
    } catch (error) {
      console.log(error);
    }
  };

  createTraining() {
    this.addNewTraining = true;
  }

  trainingPageData: any = undefined;

  hideCreateTraining(event: any) {
    if (event) {
      this.page = 1;
      this.rows = 10;
      this.first = 1;
      // this.setQueryParams(event)
      this.trainingPageData = event;
    } else this.addNewTraining = false;
    // this.newTrainingType = undefined
  }

  closeTrainingPage(event: any) {
    if (!event) return;

    this.addNewTraining = false;
    this.trainingPageData = undefined;
    this.getTrainingRequests();
  }

  // setQueryParams(parems:any) {
  //   const routeParam = parems._id;  // Route param _id
  //   const queryParams = parems;            // Query param flag

  //   // Get the current query params as string
  //   let currentUrl = this.activatedRoute.snapshot.url.map(segment => segment.path).join('/');
  //   const queryString = new URLSearchParams(queryParams as any).toString();

  //   // Update the URL with the route parameter and query string
  //   const newUrl = `${currentUrl}/?${queryString}`;

  //   // Use Location to update the browser URL without navigating
  //   this.location.go(newUrl);
  // }

  setValidators(fields: string[]) {
    fields.forEach((field) => {
      const control = this.trainingProgramForm.get(field);
      if (control) {
        control.setValidators(Validators.required);
        control.updateValueAndValidity();
      }
    });
  }

  clearValidators(fields: string[]) {
    fields.forEach((field) => {
      const control = this.trainingProgramForm.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  clearValues(fields: string[]) {
    fields.forEach((field) => {
      const control = this.trainingProgramForm.get(field);
      if (control) {
        control.setValue(null);
      }
    });
  }

  markAllFieldsTouchedAndDirty(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      control?.markAsTouched();
      control?.markAsDirty();
    });
  }

  isFieldError(field: string) {
    const control = this.trainingProgramForm?.get(field);
    if (control?.dirty && control?.touched && control?.errors?.['required']) {
      return true;
    }
    return false;
  }

  submitTrainingForm() {
    if (!this.selectedOus || this.selectedOus.length <= 0) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Please Select Ou'),
        detail: '',
      });
      return;
    }

    if (this.trainingProgramForm.valid) {
      this.activeIndex = 2;
      // You can access form values using this.myForm.value
      this.submitTrainingProgram(false);
    } else {
      this.markAllFieldsTouchedAndDirty(this.trainingProgramForm);
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Invalid Form'),
        detail: '',
      });
      console.error('Form is invalid');
    }
  }

  navigateToTrainingPage(trainingId: string, params: any) {
    const url = this.router
      .createUrlTree(['/training/training-page', trainingId], {
        queryParams: params,
      })
      .toString();
    window.open(url, '_blank');
  }

  openCourse(course: any) {
    course;
    course.trainingId._id
      ? this.navigateToTrainingPage(course.trainingId._id, { from: 'SBC' })
      : null;
  }

  submitSpinner = false;

  async submitTrainingProgram(hideForm: boolean) {
    try {
      let data: any = {
        ...this.trainingProgramForm.getRawValue(),
        ous: this.selectedOus.map((e: any) => e._id),
        start_date: this.programStartDate,
        end_date: this.programEndDate,
      };

      if (!!this.programData) {
        data._id = this.programData._id;
      }

      this.submitSpinner = true;

      let sendData = cloneDeep(data);

      if (!!this.createdProgramId) {
        sendData._id = this.createdProgramId;
        this.createdProgramId = '';
      }

      let res = await this.dataService.postData('training-program/', sendData);
      if (res.error) return;

      this.createdProgramId = res.data;

      if (hideForm) {
        this.closeForm.emit(true);
      }
      this.submitSpinner = false;
     //debugger;
    } catch (error) {
      console.log(error);
    }
  }

  refresh() {
    this.oufilter = undefined;
    this.trainingFilter = undefined;
    this.getTrainingRequests();
  }

  getTrainings() {
    this.getTrainingRequests();
    this.resetRecreateObject();
    this.trainingHolder = undefined;
    this.trainingSpinner = true;
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  flattenTree(root: TreeNode[]): any[] {
    const result: any[] = [];
    root.map((e) => this.flattenNode(e, result));
    // this.flattenNode(root, result);
    return result;
  }

  private flattenNode(node: TreeNode, result: any[]): void {
    result.push((node as any)?._id);
    if (node.children) {
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }

  selectedTreeData: any = [];
  finalTreeData: any[] = [];
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  async getTreeData() {
    this.selectedTreeData_orginal =
      await this.permissionService.extractOUChildren('TRAINING_PROGRAM', 'c');
    if (this.router.url.includes("new-branch")) {
      this.filterTreeByTag([
        'Branches',
      ]);
    } else {
      this.filterTreeByTag([
        'Ministries/Entities',
        'Organisational Units',
        'Branches',
        'Organisational Structure',
      ]);
    }
  }

  filterTreeByTag(tag: string[]) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = [];
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: [],
        });
      });
      this.selectedTreeData = cloneDeep(cloneitems);
    }
  }

  filterNodes(node: any, tag: string[]): any | null {
    // Recursively filter children nodes

    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (tag.includes(node.tag) || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }

  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  //Form Methods\

  groupCourse(data: any): FormGroup {
    return this.fb.group({
      _id: [data._id || ''],
      topic: [data.topic || ''],
      createdType: [data.createdType || ''],
      type: [data.type || ''],
      numberOfAttendees: [data.numberOfAttendees || 0],
      ous: this.fb.array(data.ous || []),
      completedAttendees: this.fb.array(data.completedAttendees || []),
      pendingAttendees: [data.pendingAttendees || null],
      lastSessionPending: [data.lastSessionPending || null],
      attendeesRequests: [data.attendeesRequests || null],
      registrationType: [data.registrationType || null],
      status: [data.status || ''],
      recreationCount: [data.recreationCount || 0],
      active: [data.active || true],
      unregisteredUsers: [data.unregisteredUsers || null],
      description: [data.description || ''],
      // trainer: this.fb.array(this.createTrainersArray(data?.trainer || [])),
      start_date: [data.start_date || ''],
      end_date: [data.end_date || ''],
      createdAt: [data.createdAt || ''],
      updatedAt: [data.updatedAt || ''],
      recreationData: [data.recreationData],
      conditions: [data.conditions],
      trainingId: this.fb.group({
        _id: [data.trainingId?._id || ''],
        title: [data.trainingId?.title || ''],
        description: [data.trainingId?.description || ''],
        type: [data.trainingId?.type || ''],
        image: [data.trainingId?.image || ''],
        end_date: [data.trainingId?.end_date || ''],
        start_date: [data.trainingId?.start_date || ''],
        sessions: this.fb.array(data.trainingId?.sessions || []),
        attendees: this.fb.array(
          data.trainingId?.attendees ? data.trainingId?.attendees : []
        ),
      }),
    });
  }

  createTrainersArray(trainers: any[]): FormGroup[] {
    console.log(trainers);
    return trainers?.map((trainer) =>
      this.fb.group({
        name: [trainer?.name || ''],
        user_id: [trainer?.user_id || ''],
        email: [trainer?.email || ''],
      })
    );
  }

  createAttendeesArray(attendees: any[]): FormGroup[] {
    return attendees.map((attendee) =>
      this.fb.group({
        _id: [attendee._id || ''],
      })
    );
  }

  labelsIdToRemove: string[] = [
    '64648e3918d4943a0a7b366a',
    '64648e7118d4943a0a7b366c',
  ];
  labelsToRemove: string[] = ["الجهات المشاركة"];
  selectedOusLabel: any;

  ouChanged(event: any) {
    this.selectedOus = this.selectedOus.filter((node: any) => {
      return !this.labelsIdToRemove.includes(node._id);
    });
    this.selectedOus = this.selectedOus.filter((node: any) => {
      return !this.labelsToRemove.includes(node.label);
    });
    this.selectedOusLabel = this.selectedOus
      .map((e: any) => e.label)
      .join(', ');
  }


  externalTrainers: any[] = [];
  internalTrainers: any[] = [];
  showInternal: boolean = true;
  trainer: any;
  addTrainerModal: boolean = false;



  internalExternal(type: any) {
    this.showInternal = !(type.checked == true);
  }
  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  handleUpdatedUserData(event: any) {
    this.getInternalTrainers();
  }

  //get internal trainners
  getInternalTrainers = async () => {
    try {
      this.externalTrainers = [];
      this.internalTrainers = [];

      let query: any = {
        'externalUser.role': 'trainer',
      };

      // if (this.branchId && this.trainingType != 'New Branch') {
      //   query.ou = this.branchId
      // }

      let res = await this.dataService.postData('user/get', query);
      if (res.error) return;

      res?.data.forEach((item: any) => {
        let trainer = {
          name: `${item?.name?.first}  ${item?.name?.middle} ${item?.name?.last}`,
          user_id: item._id,
          company_id: item?.externalUser?.company?._id,
          email: item?.email,
        };
        if (!!item.externalUser.status) {
          this.externalTrainers.push(trainer);
        } else {
          this.internalTrainers.push(trainer);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  async assNewTrainers(list: any) {
    if (list.emit == false) {
      this.addTrainerModal = false;
    }
    const arrayOfIds = list.users.map((obj: any) => obj._id);
    try {
      let res: any = await this.dataService.postData(
        'user/add-trainer',
        arrayOfIds,
        'PUT',
        false
      );
      if (res.error) {
        return;
      } else {
        this.addTrainerModal = false;
        this.getInternalTrainers();
      }
    } catch (error) {
      console.log(error);
    }
  }


  getMasterTrainer() {
    let value: any = this.trainingProgramForm.getRawValue()
    if (value.master_trainer) {
      return value.master_trainer
    } else if (this.programData?.master_trainer) {
      return this.programData?.master_trainer
    } else {
      return undefined
    }

  }
}
